import { useContext } from "react";
import { trpc } from "../../trpc";
import MerchantContext from "../../contexts/MerchantContext";
import PipedriveCrmConfiguration from "./pipedrive/PipedriveCrmConfiguration";
import SmartHomeRentalsCrmConfiguration from "./smarthome/SmartHomeRentalsCrmConfiguration";
import { Spinner } from "@/components/ui/spinner";

const PipelineCrmConfiguration = (): JSX.Element => {
  const { merchantId } = useContext(MerchantContext);

  const { data: crmConnection, isLoading: isLoadingConnection } = trpc.crmSelfConfig.get.useQuery(
    { merchantId: merchantId || "" },
    { enabled: !!merchantId }
  );

  if (isLoadingConnection) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-6">
        <div className="flex flex-row gap-2">
          <Spinner size="sm" />
          <p>Cargando configuración...</p>
        </div>
      </div>
    );
  }

  if (!crmConnection?.provider) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-6">
        <p className="text-gray-600">No hay conexión CRM configurada.</p>
      </div>
    );
  }

  // Route to the appropriate CRM component based on provider
  switch (crmConnection.provider) {
    case "pipedrive":
      return <PipedriveCrmConfiguration />;
    case "smarthome-rentals":
      return <SmartHomeRentalsCrmConfiguration />;
    default:
      return (
        <div className="rounded-xl border border-gray-200 bg-white p-6">
          <p className="text-gray-600">
            CRM provider "{crmConnection.provider}" no está soportado aún.
          </p>
        </div>
      );
  }
};

export default PipelineCrmConfiguration;
